import { Typography } from "@mui/material";
import React from "react";

const Error = () => {
  return (
    <div>
      <Typography
        textAlign="center"
        justifyContent="center"
        justifyItems="center"
        justifyself="center"
        paddingTop={30}
        color="0000"
        fontSize={100}
        fontWeight={900}
      >
        404 Error
      </Typography>
    </div>
  );
};

export default Error;
